import { useEffect, useState, useRef, useContext, createContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import styles from "./Guestiis.module.css"

import Sidebar from '../Sidebar';
import TableUtil from '../Utils/TableUtil';
import { MovingTextContainer, MovingDateTimeContainer, MovingAutocompleteContainer, MovingTagContainer } from '../Utils/Helpers'


const Banner = ({ handleOpen }) => {
	const navigate = useNavigate();
	const [showingLabel, setShowingLabel] = useState(true)
	const [search, setSearch] = useState("")
	const divRef = useRef(null);
	const [userData, setUserData] = useState({})
	const [searchResults, setSearchResults] = useState({
		events: [],
		guestiis: [],
		teamMembers: []
	})


	useEffect(() => {
		const handleLoad = async () => {
			try {
				const userId = localStorage.getItem("_id")
				const retrieve = await axios.get(`/api/hub/get-user-data/${userId}`);
				setUserData(retrieve.data.user)
			} catch (e) {
				localStorage.removeItem("_id")
				localStorage.removeItem("expiry")
				window.location = "/connect"
			}
		}

		handleLoad()
	}, []);

	const handleSearch = async (input) => {
		const userId = localStorage.getItem("_id")
		const searchTerm = input.target.value
		setSearch(searchTerm)

		if (searchTerm !== "") {
			const retrieve = await axios.get(`/api/hub/${userId}/search-all/${searchTerm}`);
			setSearchResults(retrieve.data.data)
		}
	}

	function formatDate(dateString) {
	    const date = new Date(dateString);

	    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

	    const day = days[date.getDay()];
	    const dateNumber = date.getDate();
	    const month = months[date.getMonth()];

	    const suffix =
	        dateNumber % 10 === 1 && dateNumber !== 11
	            ? 'st'
	            : dateNumber % 10 === 2 && dateNumber !== 12
	            ? 'nd'
	            : dateNumber % 10 === 3 && dateNumber !== 13
	            ? 'rd'
	            : 'th';

	    return `${day}, ${dateNumber}${suffix} ${month}`;
		}

		function convertTo24HourTime(isoString) {
	    const date = new Date(isoString);
	    const time = date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });

	    return time;
	}

	const handleClickOutside = (event) => {
  	if (divRef.current && !divRef.current.contains(event.target)) {
  		setSearch("")

			setSearchResults({
				events: [],
				guestiis: [],
				teamMembers: []
			})
  	}
	};

	const handleClickItem = (item, searchKey) => {
		const userId = localStorage.getItem("_id")

		switch (searchKey) {
			case 'events':
				var state = { from: item };
				sessionStorage.setItem('navigationState', JSON.stringify(state));

				navigate(`/hub/${userId}`)
				break;
			case 'guestiis':
				var state = { from: item };
				sessionStorage.setItem('navigationState', JSON.stringify(state));

				window.location.reload()
				break;
			case 'teamMembers':
				var state = { from: item };
				sessionStorage.setItem('navigationState', JSON.stringify(state));

				navigate(`/team/${userId}`)
				break;
		}

	}

	useEffect(() => {
  	document.addEventListener('mousedown', handleClickOutside);

  	return () => {
    		document.removeEventListener('mousedown', handleClickOutside);
  	};
	}, []);



	return (
		<div className={styles.banner_container}>
			<div className={styles.banner_greeting}>
				<h3>Hi, {userData.first_name}</h3>
				<p>Welcome back to your Guestii hub!</p>
			</div>

			<div className={styles.banner_tools}>
				<div className={styles.nevent_input_container_search}>
					<div
						className={styles.movingLabelSearch}
	        	style={{
	          	top: showingLabel && !search ? "50%" : "-20px",
	          	transform: showingLabel && !search ? "translate(0, -50%)" : "",
	          	transition: "top 0.3s ease, left 0.3s ease, transform 0.3s ease, color 0.3s ease",
	          	color: !(showingLabel && !search) && "#01000D"
	        	}}
					>
						<i className={`fa-solid fa-magnifying-glass ${styles.m1}`}></i>
						<p className={`${styles.s1}`}>Search for anything</p>
					</div>

					<input
						type="text"
						className={styles.s1}
						onChange={(input) => handleSearch(input)}
						onFocus={() => setShowingLabel(false)}
						onBlur={() => setShowingLabel(true)}
						onClick={() => setShowingLabel(false)}
						value={search}
					/>
				</div>

				{search !== "" &&
					<>
						{Object.values(searchResults).length > 0 &&
							<div className={styles.search_outer_container} ref={divRef}>
								{Object.keys(searchResults).map((searchKey) => {
									let resultItem = searchResults[searchKey]

									return (
										<>
											{resultItem.map((item) => (
												<button className={styles.searchItem} onClick={() => handleClickItem(item, searchKey)}>
													<i className={`fa-solid fa-${searchKey === "events" ? "clipboard-check" : searchKey === "guestiis" ? "clipboard-user" : "users"} ${styles.m1}`}></i>

													{searchKey === "events"
														?
															<div className={styles.searchItemContent}>
																<p className={`${styles.s1}`}>{item.name}</p>
																<p className={`${styles.xs3}`}>{formatDate(item.start_date)} {convertTo24HourTime(item.start_date)} - {formatDate(item.end_date)} {convertTo24HourTime(item.end_date)}</p>
															</div>
														:
															<div className={styles.searchItemContent}>
																<p className={`${styles.s1}`}>{item.first_name} {item.last_name}</p>
																<p className={`${styles.xs3}`}>{item.phone || "-"}</p>
															</div>
													}
													
												</button>
											))}
										</>
									)
								})}
							</div>
						}
					</>
				}

				<button className={styles.profile_btn}><i className={`fa-solid fa-user ${styles.m1}`}></i></button>
			</div>
		</div>
	)
}

const TableDisplay = ({ handleOpen, setGuestiiInvite, guestiiInvite, setGuestiiInviteOG, setShowUpdateInvites, setCollapseFilters }) => {
	const [isLoading, setIsLoading] = useState(false)
	const [showNewTeamMember, setShowNewTeamMember] = useState(false)
	const [nodes, setNodes] = useState([])
	const [allEvents, setAllEvents] = useState([])


	useEffect(() => {
		const handleLoad = async () => {
			setIsLoading(true)

			const userId = localStorage.getItem("_id")
			const expiry = localStorage.getItem("expiry")
			if (!userId || !expiry) {
				locationStorage.removeItem("_id")
				locationStorage.removeItem("expiry")
				window.location = "/connect"
			}

			try {
				const retrieve = await axios.get(`/api/guestiis/get-all-guestiis/${userId}/${expiry}`);
				setNodes(retrieve.data.allGuestiis)
				setAllEvents(retrieve.data.allEvents)
			} catch (e) {
				localStorage.removeItem("_id")
				localStorage.removeItem("expiry")
				window.location = "/connect"
			}

			setIsLoading(false)
		}

		handleLoad()
	}, []);


	const handleQuickInvite = (guestii) => {
		if (guestiiInvite && guestii._id === guestiiInvite._id) {
			setGuestiiInvite(null)
			setGuestiiInviteOG(null)
			setShowUpdateInvites(false)
		} else {
			setGuestiiInvite(guestii)
			setGuestiiInviteOG(guestii)
			setShowUpdateInvites(false)
		}
	}

	const searchControl = (event) => {
	    let input = event.target.value;
	    let filter = input.toUpperCase();
	    let target_div = document.getElementById('guestiisGrid').children

	    for (let i = 0; i < target_div.length; i++) {
	    	let showItem = false
	        let mainValue = target_div[i].getElementsByTagName("p")[0].textContent

            if (mainValue.toUpperCase().indexOf(filter) > -1) {
                showItem = true;
            }

	        if (showItem) {
	            target_div[i].style.display = "flex";
	        } else {
	            target_div[i].style.display = "none";
	        }
	    }
	};

	return (
		<div className={`${styles.widget_container} ${styles.event_widget}`}>
			<div className={styles.widget_banner}>
				<p>My Guestiis</p>
			</div>

			<div className={styles.outer_event_container}>
				<div className={styles.event_list}>
					{!isLoading
						?
							<div className={(nodes && nodes.length > 0) ? styles.guestii_layout : styles.guestii_layout_none}>
								{(nodes && nodes.length > 0)
									?
										<div className={styles.team_grid} style={{ gridTemplateRows: `repeat(${Math.ceil(nodes.length / 4)}, auto)` }}>
											{nodes.map((node, index) => {

												return (
													<>
														<button className={`${styles.team_member} ${(guestiiInvite && guestiiInvite._id === node._id) && styles.activeGuestiiInvite}`} onClick={() => handleQuickInvite(node)}>
															<div className={`${styles.team_banner}`}>
																<div className={styles.team_profile}>
																	<i class={`fa-solid fa-user ${styles.s2}`}></i>
																</div>
																<div className={styles.team_names}>
																	<p className={styles.s2}>{node.first_name} {node.last_name} {((!node.first_name || node.first_name === "") && (!node.last_name || node.last_name === "")) && "-"}</p>
																	<p className={styles.xs3}>{node.phone || "-"}</p>
																</div>
															</div>
														</button>
													</>
												)
											})}
										</div>
									: <div className={styles.noResults}><p>Create your first event to start!</p></div>
								}
							</div>
						:
							<div className={styles.guestii_layout}>
								<div className={styles.team_grid} style={{ gridTemplateRows: `repeat(2, auto)` }}>
									{Array.from({ length: 8 }).map((_, index) => (
										<button className={`${styles.team_member} ${styles.team_loading} shine-animation-light`}>
											<div className={`${styles.team_banner}`}>
												<div className={styles.team_profile}>
													<i class={`fa-solid fa-user ${styles.s2}`}></i>
												</div>
												<div className={styles.team_names}>
													<p className={`${styles.s2} ${styles.bg_dark}`}>Example Guestii</p>
													<p className={styles.xs3}>example@guestii.app</p>
												</div>
											</div>
										</button>
									))}
								</div>
							</div>
					}
				</div>
			</div>
		</div>

	)
}

const GuestiiInfoWidget = ({ setGuestiiInvite, guestiiInvite, collapseFilters }) => {
	const [isLoading, setIsLoading] = useState(false)
	const [changeMade, setChangeMade] = useState(false)
	const [activeControl, setActiveControl] = useState(null)
	const [ratingsHistory, setRatingsHistory] = useState([]);
	const [averageRating, setAverageRating] = useState(0)
	const [tagsHistory, setTagsHistory] = useState([]);
	const [innerLoading, setInnerLoading] = useState(true)
	const [editGuestii, setEditGuestii] = useState({})
	const [validationError, setValidationError] = useState(null)


	useEffect(() => {
		if (guestiiInvite) {
			setIsLoading(true)
			setEditGuestii({})
			setRatingsHistory([])
			setAverageRating(null)
			setTagsHistory([])
			setActiveControl(null)
			setIsLoading(false)
		}
	}, [guestiiInvite]);

	useEffect(() => {
		const handleLoadRating = async () => {
			const userId = localStorage.getItem("_id")
			const expiry = localStorage.getItem("expiry")
			if (!userId || !expiry) {
				locationStorage.removeItem("_id")
				locationStorage.removeItem("expiry")
				window.location = "/connect"
			}

			try {
				setInnerLoading(true)
				const retrieve = await axios.get(`/api/guestiis/get-guestii-ratings/${userId}/${guestiiInvite._id}`);
				setRatingsHistory(retrieve.data.ratings)
				setAverageRating(retrieve.data.average)
				setInnerLoading(false)
			} catch (e) {
				localStorage.removeItem("_id")
				localStorage.removeItem("expiry")
				window.location = "/connect"
			}
		}

		const handleLoadTags = async () => {
			const userId = localStorage.getItem("_id")
			const expiry = localStorage.getItem("expiry")
			if (!userId || !expiry) {
				locationStorage.removeItem("_id")
				locationStorage.removeItem("expiry")
				window.location = "/connect"
			}

			try {
				setInnerLoading(true)
				const retrieve = await axios.get(`/api/guestiis/get-guestii-tags/${userId}/${guestiiInvite._id}`);
				setTagsHistory(retrieve.data.tags)
				setInnerLoading(false)
			} catch (e) {
				localStorage.removeItem("_id")
				localStorage.removeItem("expiry")
				window.location = "/connect"
			}
		}

		if (activeControl === "Rating") handleLoadRating()
		if (activeControl === "Tags") handleLoadTags()
	}, [activeControl])

  	useEffect(() => {
    	if (!validationError) return;

    	const timer = setTimeout(() => {
      		setValidationError(null)
    	}, 5000)

    	return () => clearTimeout(timer)
  	}, [validationError])


	const handleControls = (control) => {
		setActiveControl(control)
	}

	const closeActiveControl = async () => {
		if (Object.keys(editGuestii).length > 0) {
			const confirmClose = await window.confirm("Are you sure you want to discard this edit?")

			if (confirmClose) {
				setEditGuestii({})
			}
		}

		setValidationError(null)
		setRatingsHistory([])
		setAverageRating(null)
		setTagsHistory([])
		setActiveControl(null)
	}

	const isValidEmail = (email) => {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return emailRegex.test(email);
	}

	const isValidPhone = (phone) => {
		const cleaned = phone.replace(/\s/g, '');
		const pattern = /^(?:\+?61|0)4\d{8}$/;
		return pattern.test(cleaned);
	}

	const validateEdit = async () => {
		if (editGuestii.phone && editGuestii.phone) {
			if (!isValidPhone(editGuestii.phone)) {
				setValidationError("Please enter a valid phone number")
				setEditGuestii((prev) => ({...prev, ["phone"]: ""}))
				return false;
			} else {
				// check for duplicates
				const userId = localStorage.getItem("_id")
				if (!userId) {
					locationStorage.removeItem("_id")
					locationStorage.removeItem("expiry")
					window.location = "/connect"
				}

		    	const response = await axios.post(`/api/guestiis/check-guestii-duplicates/${userId}`, { fieldToCheck: editGuestii.phone });
		    	if (response.data.valid) {
					const confirmation = await window.confirm("This will send this Guestii a sign-up email to the app to view their events.")
					if (!confirmation) {
						return false;
					}
		    	} else {
		    		setEditGuestii((prev) => ({...prev, ["phone"]: ""}))
		    		setValidationError(response.data.error)
		    		return false;
		    	}
			}
		}

		setValidationError(null)
		return true;
	}

	const handleEdit = async (control, name?, input?) => {
		switch (control) {
			case 'set':
				setValidationError(null)
				setEditGuestii((prev) => ({ ...prev, [name]: input.target.value }))
				break;
			case 'submit':
				const validation = await validateEdit()
				if (!validation) { return; }

				const userId = localStorage.getItem("_id")
				if (!userId) {
					locationStorage.removeItem("_id")
					locationStorage.removeItem("expiry")
					window.location = "/connect"
				}

				const updateResponse = await axios.post(`/api/guestiis/edit-guestii/${userId}`, {
					edit: editGuestii,
					guestii: guestiiInvite._id
				});
				const updateData = updateResponse.data.updateObj
				const newGuestii = {
				    ...guestiiInvite,
				    ...updateData
				}

				var state = { from: newGuestii };
				sessionStorage.setItem('navigationState', JSON.stringify(state));

				window.location.reload()
				break;
		}
	}

	const handleDelete = async () => {
		const confirmDelete = await window.confirm("Are you sure you want to remove this Guestii, and all their plus ones from all your events?")

		if (confirmDelete) {
			const userId = localStorage.getItem("_id")
			if (!userId) {
				locationStorage.removeItem("_id")
				locationStorage.removeItem("expiry")
				window.location = "/connect"
			}

			const updateResponse = await axios.post(`/api/guestiis/delete-guestii-main/${userId}`, {
				guestii: guestiiInvite._id
			});

			window.location.reload()
		}
	}

	return (
		<div className={`${styles.widget_container} ${activeControl && styles.overflow_hidden} ${collapseFilters && styles.quickInviteModule} ${guestiiInvite && styles.flexedModule}`}>
			{!guestiiInvite &&
				<div className={styles.widget_banner}>
					<p>Guestii Profile</p>
				</div>
			}

			{isLoading
				? <p>Loading...</p>
				:
					<>
						{guestiiInvite
							?
								<div className={styles.outerGuestiiInfo}>
									<div className={styles.profileBannerMain}>
										<div className={styles.guestii_profile}>
											<i class={`fa-solid fa-user ${styles.xl1}`}></i>
										</div>

										<div className={styles.guestii_names}>
											{activeControl === "Edit"
												?
													<>
														<input
															type="text"
															className={`${styles.guestiiInviteHeading} ${styles.m2}`}
															// placeholder="Enter name"
															onChange={(input) => handleEdit("set", "name", input)}
															defaultValue={`${((!guestiiInvite.first_name || guestiiInvite.first_name === "") && (!guestiiInvite.last_name || guestiiInvite.last_name === "")) ? "-": `${guestiiInvite.first_name} ${guestiiInvite.last_name}`}`}
															value={(editGuestii && editGuestii['name']) && editGuestii['name']}
														/>
													</>
												: <p className={styles.m2}>{guestiiInvite.first_name} {guestiiInvite.last_name}{((!guestiiInvite.first_name || guestiiInvite.first_name === "") && (!guestiiInvite.last_name || guestiiInvite.last_name === "")) ? "-" :""}</p>
											}

											{((activeControl === "Edit") && (!guestiiInvite.email && !guestiiInvite.phone && !guestiiInvite.phone))
												?
													<>
														<input
															type="text"
															className={`${styles.guestiiInviteHeading} ${styles.s3} ${validationError && styles.red_border}`}
															placeholder="Enter email/phone"
															onChange={(input) => handleEdit("set", "phone", input)}
															value={(editGuestii && editGuestii['phone']) && editGuestii['phone']}
														/>
													</>
												:
													<>
														{activeControl === "Edit"
															?
																<div className={styles.lock_flex}>
																	<i class={`fa-solid fa-lock ${styles.s3}`}></i>
																	<p className={styles.s3}>{guestiiInvite.phone || "-"}</p>
																</div>
															: <p className={styles.s3}>{guestiiInvite.phone || "-"}</p>
														}
													</>
											}

											{(activeControl === "Rating" && !innerLoading && averageRating !== 0) &&
												<div className={styles.lock_flex_inner}>
													<i className={`fa-solid fa-star ${styles.s2}`}></i>
													<p className={`${styles.s3}`} style={{ marginTop: '2.5px' }}>{averageRating}/5</p>
												</div>
											}
										</div>
									</div>


									{(!collapseFilters && !activeControl) &&
										<div className={styles.guestiiBtnsGrid}>
											<button className={styles.guestiiBtn} onClick={() =>  handleControls("Tags")}>
												<i class={`fa-solid fa-tags ${styles.statIcon}`}></i>

								            	<div className={styles.guestiiBtnText}>
								              		<p className={styles.guestiiBtnLabel}>View</p>
								              		<span className={styles.guestiiBtnValue}>Tags</span>
								            	</div>
											</button>

											<button className={styles.guestiiBtn} onClick={() => handleControls("Rating")}>
												<i class={`fa-solid fa-star ${styles.statIcon}`}></i>

								            	<div className={styles.guestiiBtnText}>
								              		<p className={styles.guestiiBtnLabel}>View</p>
								              		<span className={styles.guestiiBtnValue}>Ratings</span>
								            	</div>
											</button>

											<button className={styles.guestiiBtn} disabled={true} onClick={() => handleControls("Edit")}>
												<i class={`fa-solid fa-pen ${styles.statIcon}`}></i>

								            	<div className={styles.guestiiBtnText}>
								              		<p className={styles.guestiiBtnLabel}>Edit</p>
								              		<span className={styles.guestiiBtnValue}>Guestii</span>
								            	</div>
											</button>

											<button className={styles.guestiiBtn} disabled={true} onClick={() => handleDelete()}>
												<i class={`fa-solid fa-trash-can ${styles.statIcon}`}></i>

								            	<div className={styles.guestiiBtnText}>
								              		<p className={styles.guestiiBtnLabel}>Delete</p>
								              		<span className={styles.guestiiBtnValue}>Guestii</span>
								            	</div>
											</button>
										</div>
									}

									{activeControl &&
										<button className={styles.removeActiveControl} onClick={() => closeActiveControl()}>
											<i className={`fa-regular fa-arrow-left ${styles.m3}`}></i>
										</button>
									}

									{(activeControl === "Tags") &&
										<div className={`${styles.ratingsContainerOuter} ${tagsHistory.length === 0 && styles.ratingsContainerCenter}`}>
											{!innerLoading &&
									            <>
									            	{tagsHistory.length > 0
									            		?
											            	<>
												            	{tagsHistory.map((tag, i) => {
												            		return (
																		<div id={i} className={styles.ratingsItem}>
																			<div id={i} className={styles.ratingsItemHeading}>
																				<p className={styles.s1}>{tag.source.first_name} {tag.source.last_name}</p>
																				<p className={styles.xs3}>{tag.source_model === "TeamMember" ? tag.source.role.name : "SuperAdmin"}</p>
																				<p className={styles.xs3}>{tag.event.name}</p>
																			</div>

																			<div className={styles.tagsContainer}>
																            	{tag.tags.join(", ")}
															            	</div>

															            	{(i !== tagsHistory.length - 1) && <div className={styles.ratingsItemBorder}/>}
																		</div>
												            		)
												            	})}
											            	</>
											            :
												            <div className={styles.preModule}>
												            	<i className={`fa-solid fa-tags ${styles.xl1}`}></i>
												            	<p className={`${styles.s1}`}>This Guestii has not been assigned tags yet</p>
												            </div>
									            	}
									            </>
								            }
								        </div>
									}

									{(activeControl === "Rating") && 
										<div className={`${styles.ratingsContainerOuter} ${ratingsHistory.length === 0 && styles.ratingsContainerCenter}`}>
											{!innerLoading &&
									            <>
									            	{ratingsHistory.length > 0
									            		?
											            	<>
												            	{ratingsHistory.map((rating, i) => {
												            		return (
																		<div id={i} className={styles.ratingsItem}>
																			<div id={i} className={styles.ratingsItemHeading}>
																				<p className={styles.s1}>{rating.source.first_name} {rating.source.last_name}</p>
																				<p className={styles.xs3}>{rating.source_model === "TeamMember" ? rating.source.role.name : "SuperAdmin"}</p>
																				<p className={styles.xs3}>{rating.event.name}</p>
																			</div>

																			<div className={styles.reviewContainer}>
																            	{Array.from({ length: 5 }).map((_, i) => {
																            		return (
																						<div className={styles.starContainer}>
																							<i className={`fa-${rating.rating >= i+1 ? "solid" : "regular"} fa-star ${styles.m3}`}></i>
																						</div>
																            		)
																            	})}
															            	</div>

															            	{(i !== ratingsHistory.length - 1) && <div className={styles.ratingsItemBorder}/>}
																		</div>
												            		)
												            	})}
												            </>
											            :
												            <div className={styles.preModule}>
												            	<i className={`fa-solid fa-star ${styles.xl1}`}></i>
												            	<p className={`${styles.s1}`}>This Guestii has not been assigned ratings yet</p>
												            </div>
									            	}
									            </>
								            }
								        </div>
									}

									{(activeControl === "Edit" && Object.keys(editGuestii).length > 0) &&
										<>
											{validationError
												?
													<div className={styles.validation_error}>
														<p className={styles.s1}>{validationError}</p>
													</div>
												: <button className={styles.editSubmit} onClick={() => handleEdit("submit")}><p className={styles.s2}>Update</p></button>
											}
										</>
									}
								</div>
							:
								<div className={styles.preModule}>
									<i className={`fa-solid fa-user ${styles.xl1}`}></i>
									<p className={`${styles.s1}`}>Click on a Guestii to view their information and tags</p>
								</div>
						}
					</>
			}

		</div>
	)
}


const QuickInviteWidget = ({ setGuestiiInvite, guestiiInvite, collapseFilters, guestiiInviteOG, setShowUpdateInvites, showUpdateInvites, setCollapseFilters }) => {
	const [isLoading, setIsLoading] = useState(false)
	const [allEvents, setAllEvents] = useState([])


	useEffect(() => {
		const handleLoad = async () => {
			setIsLoading(true)

			const userId = localStorage.getItem("_id")
			const expiry = localStorage.getItem("expiry")
			if (!userId || !expiry) {
				locationStorage.removeItem("_id")
				locationStorage.removeItem("expiry")
				window.location = "/connect"
			}

			try {
				const retrieve = await axios.get(`/api/guestiis/get-all-guestiis/${userId}/${expiry}`);
				setAllEvents(retrieve.data.allEvents)
			} catch (e) {
				localStorage.removeItem("_id")
				localStorage.removeItem("expiry")
				window.location = "/connect"
			}

			setIsLoading(false)
		}

		handleLoad()
	}, []);

	const handleForm = () => {

	}

	const mappedMatches = (checking, against) => {
		let doesContain = checking.length === against.length;

		checking.forEach((check) => {
			if (!(against.includes(check))) {
				doesContain = false
			}
		})

		return doesContain
	}

	const checkInvite = async (event) => {
		setCollapseFilters(true)
		let guestiiDup = { ...guestiiInvite }
		let guestiiDupOG = { ...guestiiInviteOG }

		let eventsDup = [ ...guestiiDup['events'] ]
		let eventsDupOG = [ ...guestiiDupOG['events'] ]

		if (eventsDup.filter(e => e._id === event._id).length > 0) {
			let eventsFiltered = eventsDup.filter(e => e._id !== event._id)
			guestiiDup['events'] = eventsFiltered
		} else {
			eventsDup.push(event)
			guestiiDup['events'] = eventsDup
		}

		let newEventsMapped = guestiiDup.events.map(event => event.name)
		let ogEventsMapped = eventsDupOG.map(eventOG => eventOG.name)

		if (mappedMatches(newEventsMapped, ogEventsMapped)) {
			setShowUpdateInvites(false)
		} else {
			setShowUpdateInvites(true)
			setCollapseFilters(true)
		}

		setGuestiiInvite(guestiiDup)
	}

	const submitNewInvites = async () => {
    	const response = await axios.post(`/api/guestiis/update-invites`, {
      		events: guestiiInvite.events,
      		guestii: guestiiInvite._id,
    	});

    	window.location.reload()
	}

	const searchControl = (event) => {
	    let input = event.target.value;
	    let filter = input.toUpperCase();
	    let target_div = document.getElementById('guestiisGrid').children

	    for (let i = 0; i < target_div.length; i++) {
	    	let showItem = false
	        let mainValue = target_div[i].getElementsByTagName("p")[0].textContent

            if (mainValue.toUpperCase().indexOf(filter) > -1) {
                showItem = true;
            }

	        if (showItem) {
	            target_div[i].style.display = "flex";
	        } else {
	            target_div[i].style.display = "none";
	        }
	    }
	};

	return (
		<div className={`${styles.widget_container} ${styles.quickInviteContainer} ${!collapseFilters && styles.quickInviteModule} ${guestiiInvite && styles.widget_container_extra}`}>
			<div className={styles.widget_banner}>
				<p>Quick Invite</p>
			</div>

			{guestiiInvite &&
				<MovingTextContainer
					label={"Search events..."}
					icon={"fa-solid fa-magnifying-glass"}
					// handleForm={searchControl}
					formData={{}}
					dashboard={true}
				/>
			}


			{!isLoading && 
				<>
					{!guestiiInvite
						?
							<div className={styles.preModule}>
								<i className={`fa-solid fa-plus ${styles.xl1}`}></i>
								<p className={`${styles.s1}`}>Click on a Guestii to quick invite them to an event</p>
							</div>

						:
							<>
					      		{allEvents.length > 0
					      			?
					      				<div id="guestiisGrid" className={styles.guestiisGrid} style={{ gridTemplateRows: `repeat(${Math.ceil(allEvents.length / 2)}, max-content)` }}>
					      					{allEvents.map((event_na, index) => {
					      						let isLast = index === allEvents.length - 1
					      						let guestiisFiltered = guestiiInvite?.events?.filter(event => event.name === event_na.name) || []
					      						
					      						return (

													<button disabled={true} className={`${styles.quickInvite_member} ${(guestiisFiltered.length > 0) && styles.activeGuestiiInvite}`} onClick={() => checkInvite(event_na)}>
														<p className={styles.s1}>{event_na.name}</p>
													</button>
					      						)
					      					})}
						              	</div>
					      			: <p>No events...</p>
			      				}

			      				{(showUpdateInvites && collapseFilters) &&
			      					<button className={styles.quickInviteSubmit} onClick={() => submitNewInvites()}><p className={styles.s2}>Update</p></button>
			      				}
							</>
					}
				</>
			}


		</div>
	)
}

const ToggleBar = ({ collapseFilters, setCollapseFilters }) => {
	const [collapseDeg, setCollapseDeg] = useState(0)
	

    const handleCollapse = async (control) => {
    	let intervalId;

        switch (control) {
            case 'enter':
            	if (collapseDeg !== 0) {
            		setCollapseDeg(0)
            	}

            	if (collapseDeg !== 15) {
	                intervalId = setInterval(() => {
	                    setCollapseDeg(prevDeg => {
	                        if (prevDeg >= 15) {
	                            clearInterval(intervalId);
	                            return prevDeg;
	                        }
	                        return prevDeg + 1;
	                    });
	                }, 10);
            	}
                break;
            case 'leave':
                intervalId = setInterval(() => {
                    setCollapseDeg(prevDeg => {
                        if (prevDeg === 0) {
                            clearInterval(intervalId);
                            return prevDeg;
                        }
                        return prevDeg - 1;
                    });
                }, 10);
                break;
             case 'toggle':
             	setCollapseDeg(0)
             	setCollapseFilters(!collapseFilters)
             	break;
        }
    };


	return (
		<div className={styles.toggle_bar_container}>
			<div 
				className={`${styles.collapseInner} ${collapseDeg === 0 && styles.collapseOpacitated}`}
				onMouseEnter={() => handleCollapse('enter')}
				onMouseLeave={() => handleCollapse('leave')}
				onClick={() => handleCollapse('toggle')}
			>
	        	<div className={styles.collapseBtn} style={{transform: `translateY(0.15rem) rotate(${collapseFilters ? "-" : ""}${collapseDeg}deg) translateZ(0px)`}}></div>
	        	<div className={styles.collapseBtn} style={{transform: `translateY(-0.15rem) rotate(${(!collapseFilters && collapseDeg !== 0) ? "-" : ""}${collapseDeg}deg) translateZ(0px)`}}></div>
	        </div>
		</div>

	)
}


const GuestiisPage = ({ handleOpen, setGuestiiInvite, guestiiInvite, setGuestiiInviteOG, guestiiInviteOG }) => {
	const [collapseFilters, setCollapseFilters] = useState(false)
	const [showUpdateInvites, setShowUpdateInvites] = useState(true)
	const current = "Guestiis"

	
	return (
		<div className={`${styles.container_outer} ${styles.fadeContainer}`}>
			<div className={styles.container}>
				<Sidebar { ... { current } }/>

				<div className={styles.content_container}>
					<Banner { ... { handleOpen } }/>

					<div className={styles.hub_layout}>
						<TableDisplay {... { handleOpen, setGuestiiInvite, guestiiInvite, setGuestiiInviteOG, setShowUpdateInvites, setCollapseFilters } }/>

						<div className={styles.hub_secondary_layout}>
							<GuestiiInfoWidget { ... { setGuestiiInvite, guestiiInvite, collapseFilters } }/>
							<ToggleBar { ... { collapseFilters, setCollapseFilters } }/>
							<QuickInviteWidget { ... { setGuestiiInvite, guestiiInvite, collapseFilters, guestiiInviteOG, setShowUpdateInvites, showUpdateInvites, setCollapseFilters } }/>
						</div>
					</div>
					

				</div>
			</div>
		</div>
	)
}

const Guestiis = () => {
	const [isLoading, setIsLoading] = useState(false);
	const [isAuthenticated, setIsAuthenticated] = useState(true);
	const [indTeamMember, setIndTeamMember] = useState(null)
	const [tempFormData, setTempFormData] = useState(null)
	const [isOpen, setIsOpen] = useState(null)
	const [guestiiInvite, setGuestiiInvite] = useState(null)
	const [guestiiInviteOG, setGuestiiInviteOG] = useState(null)


	useEffect(() => {
		const checkForNavigate = () => {
			const fromState = JSON.parse(sessionStorage.getItem('navigationState'));

			if (fromState) {
				setGuestiiInvite(fromState.from)
				setGuestiiInviteOG(fromState.from)
				sessionStorage.removeItem('navigationState');
			}
		}

		checkForNavigate()
	}, []);


	function handleOpen(target, teamMember?) {
		switch (target) {
			case 'edit':
				setIsOpen("new")
				setTempFormData(teamMember)
				break;
			case 'close':
				setIsOpen(null)
				setTempFormData(null)
				setIndTeamMember(null)
				break;
			default:
				setIsOpen(target)
				setIndTeamMember(teamMember)
		}
	}

	return (
		// <div className={`${styles.overlay} ${(isOpen) && styles.white_overlay}`}>
		// 	<div className={`${isOpen && styles.hidden_container} ${styles.fadeContainer}`}>
		// 		<GuestiisPage {... { handleOpen, setGuestiiInvite, guestiiInvite, setGuestiiInviteOG, guestiiInviteOG } }/>
		// 	</div>
		// </div>

		<GuestiisPage {... { handleOpen, setGuestiiInvite, guestiiInvite, setGuestiiInviteOG, guestiiInviteOG } }/>
	);
};

export default Guestiis;